/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_3Inputs */



/**
* | output |
* | --- |
* | "Automatic Alignment & Sync" |
*
* @param {Signup_Feature_Pro_3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_3 = /** @type {((inputs?: Signup_Feature_Pro_3Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_3Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
	return /** @type {LocalizedString} */ ("Automatic Alignment & Sync")
});